import { useRef, useState, useEffect, useCallback } from 'react';

// Sincroniza una barra de desplazamiento horizontal superior con el contenedor
// de una tabla ancha. Devuelve los refs y handlers para enganchar ambos
// elementos, y el ancho real del contenido para dimensionar la barra superior.
//
// `deps` debe incluir los valores que cambian el ancho de la tabla (datos,
// filtros, sub-pestaña activa) para recalcular el ancho cuando corresponde.
export const useHorizontalScrollSync = (deps = []) => {
  const topRef = useRef(null);
  const contentRef = useRef(null);
  const [contentWidth, setContentWidth] = useState(0);

  const sync = useCallback((sourceRef, targetRef) => {
    if (!sourceRef.current || !targetRef.current) return;
    const { scrollLeft } = sourceRef.current;
    if (targetRef.current.scrollLeft !== scrollLeft) {
      targetRef.current.scrollLeft = scrollLeft;
    }
  }, []);

  const onTopScroll = useCallback(() => sync(topRef, contentRef), [sync]);
  const onContentScroll = useCallback(() => sync(contentRef, topRef), [sync]);

  useEffect(() => {
    if (contentRef.current) {
      setContentWidth(contentRef.current.scrollWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { topRef, contentRef, contentWidth, onTopScroll, onContentScroll };
};
